module.exports = __webpack_public_path__ + "static/media/day16_longtap.d2f9acaf.gif";